// EXTERNAL DEPENDENCIES
import React, { useEffect, useState } from 'react'

// HELPERS
import { useMutationCheck } from '@/hooks'

// COMPONENTS
import { Button } from '@paypalcorp/pp-react'

/**
 * Displays button with loading state that resets on invalid results
 */
export default function ButtonWithState({
  children,
  canProceed,
  shouldShowSpinner,
  onClick,
  updateClickStatus,
  ...props
}: {
  children: string
  canProceed: boolean
  shouldShowSpinner?: boolean
  onClick: (e?: React.FormEvent<HTMLFormElement>) => void
  updateClickStatus?: (isClicked: boolean) => void
}) {
  const isMutating = useMutationCheck()
  const [buttonClicked, setButtonClicked] = useState(false)

  useEffect(() => {
    updateClickStatus?.(buttonClicked)
  }, [buttonClicked, updateClickStatus])

  useEffect(() => {
    if (buttonClicked && canProceed) {
      setButtonClicked(false)
      onClick?.()
    } else if (canProceed === false) {
      setButtonClicked(false)
    }
  }, [buttonClicked, canProceed, onClick])

  /**
   * Invokes the provided onClick and sets buttonClicked to true
   */
  const handleButtonClick = (e: React.FormEvent<HTMLFormElement>) => {
    setButtonClicked(true)
    onClick(e)
  }

  return (
    <Button
      {...props}
      onClick={handleButtonClick}
      btnState={
        (isMutating && buttonClicked) || shouldShowSpinner
          ? 'processing'
          : 'initial'
      }
    >
      {children}
    </Button>
  )
}
